<!-- Backdrop -->
<div
  *ngIf="isOpen || isClosing"
  class="modal-backdrop"
  (click)="onBackdropClick()"
></div>

<!-- Modal -->
<main
  class="modal-container offcanvas"
  [ngClass]="{ show: isOpen && !isClosing, hide: isClosing }"
  (animationend)="onAnimationEnd()"
>
  <ng-content></ng-content>
</main>
